import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "e1a4e8f2-ee69-4e5f-b60a-2743b28a7857",
    content: "Answer A",
    options: { image: `${config.ASSETS_URL}/04/30/task/task-1-answer-a.svg` },
  },
  {
    id: "fa61cda6-b552-4885-8b48-67c12795a8c5",
    content: "Answer B",
    options: { image: `${config.ASSETS_URL}/04/30/task/task-1-answer-b.svg` },
  },
  {
    id: "ff07ba9d-a9bb-4cd0-b33d-e4b1e9d4344e",
    content: "Answer C",
    options: { image: `${config.ASSETS_URL}/04/30/task/task-1-answer-c.svg` },
  },
  {
    id: "a1e972e2-334b-42a2-abe7-dfd1499504d8",
    content: "Answer D",
    options: { image: `${config.ASSETS_URL}/04/30/task/task-1-answer-d.svg` },
  },
];

export const task: Task = {
  id: "60c19e28-3c0c-4cb2-843e-30c5290ef472",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["a1e972e2-334b-42a2-abe7-dfd1499504d8"],
};
